// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import { renderTechnologyImage } from "Content/Shared/Helpers/Functions/Hooks"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  list: Array<string>
}

const RowList: React.FC<PropsType> = (props) => {
  return (
    <Row>
      {props.list.map((tech) => {
        const image = renderTechnologyImage(tech)
        return (
          <IconWrap>
            <IconImageWrap>
              <Image src={image} />
            </IconImageWrap>
            <span>{tech}</span>
          </IconWrap>
        )
      })}
    </Row>
  )
}

/////////////////////////////////////////////////////////////////////////////

const VERTICAL_MARGIN = 25
const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: ${VERTICAL_MARGIN}px;
  margin-bottom: -${VERTICAL_MARGIN + 10}px;

  @media (max-width: 800px) {
    justify-content: space-between;
  }
`

const IconWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  margin-bottom: ${VERTICAL_MARGIN + 5}px;
  text-align: center;

  width: 96px;
  @media (max-width: 545px) {
    width: 50%;
  }

  span {
    width: 96%;
  }
`

const ICON_SIZE = 46
const IconImageWrap = styled.div`
  @media (min-width: 545px) {
    height: ${ICON_SIZE}px;
    width: ${ICON_SIZE}px;
  }

  background-color: #19204d;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  overflow: hidden;
  margin-bottom: 10px;
`

const DECREASE_VALUE = 18
const Image = styled.img`
  height: ${ICON_SIZE - DECREASE_VALUE}px;
  width: ${ICON_SIZE - DECREASE_VALUE}px;
`

export default React.memo(RowList, memoComparison)
